var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90565 0.615796C1.54222 0.293159 1.00221 0.346021 0.698782 0.732456C0.395349 1.11889 0.445064 1.69399 0.808498 2.01571L5.09427 6.57273C5.13455 6.60919 5.18255 6.62651 5.22713 6.65385C5.26227 6.67572 5.29313 6.70124 5.3317 6.71765C5.43199 6.75957 5.53656 6.78418 5.64285 6.78418C5.74913 6.78418 5.85371 6.75957 5.95399 6.71765C5.99257 6.70124 6.02342 6.67572 6.05857 6.65385C6.10314 6.62651 6.15114 6.60919 6.19142 6.57273L10.4772 2.01571C10.8415 1.69399 10.8903 1.11889 10.5869 0.732456C10.2843 0.346021 9.74433 0.293159 9.38004 0.615796L6.5 3.92693L5.64292 4.83825L4.78377 3.92472L1.90565 0.615796Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.7f20b04d4ee2f85794f0d1a5214341cf.svg";
export { ForwardRef as ReactComponent };